const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3TTS {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'ttsExt', name: '🗣️ 読み上げ', color1: '#9C27B0', color2: '#7B1FA2',
            blocks: [
                { opcode: 'speak', blockType: BlockType.COMMAND, text: '[T] を読み上げる', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'こんにちは' } } },
                { opcode: 'speakLang', blockType: BlockType.COMMAND, text: '[T] を [L] 語で読み上げる', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'Hello' }, L: { type: ArgumentType.STRING, menu: 'langs', defaultValue: 'ja-JP' } } },
                { opcode: 'setRate', blockType: BlockType.COMMAND, text: '読み上げ速度を [R] に', arguments: { R: { type: ArgumentType.NUMBER, defaultValue: 1 } } },
                { opcode: 'setPitch', blockType: BlockType.COMMAND, text: 'ピッチを [P] に', arguments: { P: { type: ArgumentType.NUMBER, defaultValue: 1 } } },
                { opcode: 'stop', blockType: BlockType.COMMAND, text: '読み上げを止める' }
            ],
            menus: { langs: { items: ['ja-JP', 'en-US', 'en-GB', 'zh-CN', 'ko-KR', 'fr-FR', 'de-DE', 'es-ES'] } }
        };
    }
    _rate = 1; _pitch = 1;
    speak(args) { var u = new SpeechSynthesisUtterance(Cast.toString(args.T)); u.lang = 'ja-JP'; u.rate = this._rate; u.pitch = this._pitch; speechSynthesis.speak(u); }
    speakLang(args) { var u = new SpeechSynthesisUtterance(Cast.toString(args.T)); u.lang = args.L; u.rate = this._rate; u.pitch = this._pitch; speechSynthesis.speak(u); }
    setRate(args) { this._rate = Math.max(0.1, Math.min(10, Cast.toNumber(args.R))); }
    setPitch(args) { this._pitch = Math.max(0, Math.min(2, Cast.toNumber(args.P))); }
    stop() { speechSynthesis.cancel(); }
}
module.exports = Scratch3TTS;